import React, { Component } from 'react';
import { BroadCastSession, ClassroomSession, ConferenceCall, Scheduled } from '../../../utils/common/NamingTerms';
import LanguageContext, { LanguageProvider } from '../../../utils/common/LanguageContext';

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

class SessionStatusButton extends Component {
    // Render Appointment Status Button
    renderAppointmentStatusButton(status, visitId) {
        const joinText = this.props.joinText || this.props.t('enterSession');
        const buttonClassName = `inline-flex justify-center text-sm rounded-lg font-medium lg:px-3 px-2 sm:py-1.5 lg:py-3 w-40 ${
            this.props.hideCursor ? 'cursor-default' : ''
        }`;

        if (/Missed$/i.test(status)) {
            const missedText =
                status === 'Team Member Missed'
                    ? this.props.t('teamMemberMissed')
                    : status === 'Owner Missed'
                      ? this.props.t('ownerMissed')
                      : status === 'Doctor Missed'
                        ? this.props.t('doctorMissed')
                        : status;
            return (
                <button
                    type="button"
                    className={`${buttonClassName} text-white bg-danger`}
                    onClick={() => {
                        this.props.navigateToDetailScreen('waitingRoom', visitId);
                    }}
                >
                    {missedText}
                </button>
            );
        } else if (status === 'Booked' || status === Scheduled) {
            return (
                <button
                    type="button"
                    className={`${buttonClassName} text-white bg-UIprimary`}
                    onClick={() => {
                        this.props.navigateToDetailScreen('waitingRoom', visitId);
                    }}
                >
                    {this.props.t('scheduled')}
                </button>
            );
        } else if (status === 'In Waiting Room') {
            return (
                <button
                    type="button"
                    className={`${buttonClassName} text-gray ring-1 ring-inset ring-gray`}
                    onClick={() => {
                        this.props.navigateToDetailScreen('waitingRoom', visitId);
                    }}
                >
                    {this.props.t('inWaitingRoom')}
                </button>
            );
        } else if (status === 'Enter Virtual Class Room') {
            return (
                <button
                    type="button"
                    className={`${buttonClassName} text-emerald ring-1 ring-inset ring-emerald`}
                    onClick={() => {
                        const { sessionType } = this.props;
                        const visitType =
                            sessionType === ClassroomSession 
                                ? 'class_room'
                                : sessionType === BroadCastSession
                                  ? 'broadcast' :  sessionType === ConferenceCall
                                  ? 'conference_call' : 'one_to_one';
                        sessionStorage.setItem('SESSION_TYPE', sessionType);
                        sessionStorage.setItem('hasJoinedSession', 'true');
                        this.props.navigateToDetailScreen(visitType, visitId);
                    }}
                >
                    {joinText}
                </button>
            );
        } else if (status === 'Visit In Call') {
            return (
                <button
                    type="button"
                    className={`${buttonClassName} text-emerald ring-1 ring-inset ring-emerald`}
                    onClick={() => {
                        if (this.props.isStudentSessionList) {
                            this.props.navigateToDetailScreen('waitingRoom', visitId);
                        } else {
                            const { sessionType } = this.props;
                            const visitType =
                                sessionType === ClassroomSession 
                                    ? 'class_room'
                                    : sessionType === BroadCastSession
                                      ? 'broadcast' : sessionType === ConferenceCall
                                      ? 'conference_call'
                                      : 'one_to_one';
                            sessionStorage.setItem('SESSION_TYPE', sessionType);
                            this.props.navigateToDetailScreen(visitType, visitId);
                        }
                    }}
                >
                    {this.props.t('inCall')}
                </button>
            );
        } else if (status === 'Completed') {
            return (
                <button
                    type="button"
                    className={`${buttonClassName} text-white bg-success`}
                    onClick={() => {
                        this.props.navigateToDetailScreen('waitingRoom', visitId);
                    }}
                >
                    {this.props.t('completed')}
                </button>
            );
        } else if (status === 'Pending') {
            return (
                <button
                    type="button"
                    className={`${buttonClassName} text-warning ring-1 ring-inset ring-warning`}
                    onClick={() => {
                        this.props.navigateToDetailScreen('waitingRoom', visitId);
                    }}
                >
                    {this.props.t('pending')}
                </button>
            );
        } else if (status === 'Note Pending') {
            return (
                <button
                    type="button"
                    className={`${buttonClassName} text-white`}
                    style={{ backgroundColor: '#2987D3' }}
                    onClick={() => {
                        this.props.navigateToDetailScreen('waitingRoom', visitId);
                    }}
                >
                    {this.props.t('notePending')}
                </button>
            );
        } else {
            return (
                <button
                    type="button"
                    className={`${buttonClassName}text-white bg-danger`}
                    onClick={() => {
                        this.props.navigateToDetailScreen('waitingRoom', visitId);
                    }}
                >
                    {this.props.t('cancelled')}
                </button>
            );
        }
    }

    renderStatus(status) {
        const statusClassName = `inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${
            this.props.hideCursor ? 'cursor-default' : ''
        }`;

        if (/Missed$/i.test(status)) {
            const missedText =
                status === 'Team Member Missed'
                    ? this.props.t('teamMemberMissed')
                    : status === 'Owner Missed'
                      ? this.props.t('ownerMissed')
                      : status === 'Doctor Missed'
                        ? this.props.t('doctorMissed')
                        : status;
            return (
                <span
                    className={`${statusClassName} bg-danger/10 ring-inset ring-danger/10 text-danger`}
                >
                    {missedText}
                </span>
            );
        } else if (status === 'Booked' || status === Scheduled) {
            return (
                <span
                    className={`${statusClassName} bg-emerald/10 ring-inset ring-emerald/10 text-emerald`}
                >
                    {this.props.t('scheduled')}
                </span>
            );
        } else if (status === 'In Call' || status === 'Visit In Call') {
            return (
                <span
                    className={`${statusClassName} bg-emerald/10 ring-inset ring-emerald/10 text-emerald`}
                >
                    {this.props.t('inCall')}
                </span>
            );
        } else if (status === 'In Waiting Room') {
            return (
                <span className={`${statusClassName} bg-gray/10 ring-inset ring-gray/10 text-gray`}>
                    {this.props.t('inWaitingRoom')}
                </span>
            );
        } else if (status === 'Enter Virtual Class Room') {
            return (
                <span
                    className={`${statusClassName} bg-emerald/10 ring-inset ring-emerald/10 text-emerald`}
                >
                    {this.props.t('join')}
                </span>
            );
        } else if (status === 'Completed') {
            return (
                <span
                    className={`${statusClassName} bg-success/10 ring-inset ring-success/10 text-success`}
                >
                    {this.props.t('completed')}
                </span>
            );
        } else if (status === 'Pending') {
            return (
                <span
                    className={`${statusClassName} bg-warning/10 ring-inset ring-warning/10 text-warning`}
                >
                    {this.props.t('pending')}
                </span>
            );
        } else if (status === 'Note Pending') {
            return (
                <span
                    className={`${statusClassName} bg-danger/10 ring-inset ring-danger/10 text-danger`}
                >
                    {this.props.t('notePending')}
                </span>
            );
        } else {
            return (
                <span className={`${statusClassName} bg-red/10 ring-inset ring-red/10 text-red`}>
                    {this.props.t('cancelled')}
                </span>
            );
        }
    }

    render() {
        return (
            <>
                {!this.props.institutionList
                    ? this.renderAppointmentStatusButton(this.props.status, this.props.visitId)
                    : this.renderStatus(this.props.status)}
            </>
        );
    }
}

const ConnectedSessionStatusButton = withLanguage(SessionStatusButton);

export default (props) => (
    <LanguageProvider>
        <ConnectedSessionStatusButton {...props} />
    </LanguageProvider>
);
